import { get, set } from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { usePortal } from '@project44/ui-utils';

import { FloatInAnimation } from '../FloatInAnimation';
import CloseIcon from './closeIcon';

import { BodyContainer, Close, MessageContainer } from './styles';

interface InformationMessageProps {
  children: React.ReactNode;
  id: string;
  dismissCount?: number;
  autoCloseTimeout?: number;
}

export const TutorialMessage = ({
  id,
  children,
  dismissCount,
  autoCloseTimeout,
}: InformationMessageProps) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const target = usePortal(`tutorial-message-${id}`);

  const dismissIndentifier = `tutorial-${id}`;

  const getDismissCount = (): number => Number(get(dismissIndentifier)) || 0;
  const setDismissCount = (num: number) => set(dismissIndentifier, String(num));

  const currentDismissCount = getDismissCount();

  useEffect(() => {
    if (dismissCount === undefined) {
      setIsVisible(true);
    } else {
      setIsVisible(
        currentDismissCount < dismissCount &&
          !sessionStorage.getItem(dismissIndentifier),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClose = () => {
    setDismissCount(currentDismissCount + 1);
    sessionStorage.setItem(dismissIndentifier, 'true');
    setIsVisible(false);
  };

  useEffect(() => {
    if (autoCloseTimeout) {
      setTimeout(() => {
        setIsVisible(false);
      }, autoCloseTimeout);
    }
  }, [autoCloseTimeout]);

  return createPortal(
    <FloatInAnimation key={id} variant="bottom" visible={isVisible}>
      <BodyContainer>
        <MessageContainer>{children}</MessageContainer>
        <Close onClick={onClose} data-testid="tutorial-close">
          <CloseIcon />
        </Close>
      </BodyContainer>
    </FloatInAnimation>,
    target,
  );
};
